/* ══════════════════════════════════════════════════════════════════════
   «MIS CUESTIONARIOS» · CÓDIGO TRAÍDO DE FISIOVISIÓN, TAL CUAL
   ----------------------------------------------------------------------
   Es `pintarPendientes()` del prototipo (prototipo/paciente.html) con sus
   ayudantes, COPIADA. Lo único adaptado, según la norma:
     · los datos entran por parámetro en vez de leerse de una variable global
     · devuelve el HTML en vez de escribirlo en el DOM (para pintarlo en React)
     · el botón «Responder» lleva data-resp con el id, para poder engancharlo
   NADA MÁS. Ni un texto, ni una medida, ni un color.
   ⚠️ Si hay que cambiar algo, se cambia en el prototipo y se vuelve a traer.
   Ver NORMA_CLONAR_NO_INVENTAR.md
   ══════════════════════════════════════════════════════════════════════ */

function minutosTexto(m){
  return m < 1 ? Math.round(m*60) + ' segundos'
       : Math.round(m) + (Math.round(m) === 1 ? ' minuto' : ' minutos');
}

function haceCuanto(iso){
  var d = Math.round((new Date().setHours(0,0,0,0) - new Date(iso+'T00:00:00')) / 86400000);
  return d <= 0 ? 'Enviado hoy'
       : d === 1 ? 'Enviado ayer'
       : 'Enviado hace ' + d + ' días';
}

function fechaCorta(iso){
  try{
    return new Date(iso+'T00:00:00').toLocaleDateString('es-ES',{day:'numeric',month:'long'});
  }catch(e){ return iso; }
}

function pintarPendientes(CUEST_PENDIENTES, CUEST_CITA){
  var n = CUEST_PENDIENTES.length;
  if(!n) return '';

  /* el tiempo total, sumado · si te piden tres cosas, lo primero que
     quieres saber es cuánto te va a costar */
  var mins = CUEST_PENDIENTES.reduce(function(a,c){ return a + c.minutos; }, 0);
  var total = mins < 1 ? 'menos de 1 min' : '~' + Math.round(mins) + ' min';

  return (
    '<div class="fv-pend">'+
      '<div class="fv-pend__cab">'+
        '<div class="fv-pend__cab-izq">'+
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 4V3h6v1"/><path d="M9 10h6M9 14h4"/></svg>'+
          '<b>'+(n===1 ? 'Thais te ha enviado un cuestionario'
                       : 'Thais te ha enviado '+n+' cuestionarios')+
            ' · '+total+' en total</b>'+
        '</div>'+
        (CUEST_CITA ? '<span class="fv-pend__cita">antes de tu cita del <b>'+CUEST_CITA.texto+'</b></span>' : '')+
      '</div>'+

      '<div class="fv-pend__rejilla">'+
        CUEST_PENDIENTES.map(function(c){
          var dias = Math.round((new Date().setHours(0,0,0,0) - new Date(c.enviado+'T00:00:00'))/86400000);
          return '<div class="fv-pend__carta">'+
            '<span class="fv-pend__ico es-'+c.color+'">'+
              '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">'+c.ico+'</svg>'+
            '</span>'+
            '<b>'+c.nombre+'</b>'+
            '<small>'+c.preguntas+(c.preguntas===1?' pregunta · ':' preguntas · ')+minutosTexto(c.minutos)+'</small>'+
            '<small class="'+(dias>=7?'es-viejo':'')+'">'+haceCuanto(c.enviado)+'</small>'+
            /* «COMPLETAR» si lo dejó a medias · Ann, 28-ago-2026.
               No es solo la palabra: es que sepa que su trabajo NO se ha
               perdido. Si pone «Responder» da por hecho que empieza otra vez,
               y con eso muchos ya no vuelven a entrar. */
            '<button class="fv-btn fv-btn--primario fv-btn--paciente" data-resp="'+c.id+'">'+
              (c.empezado ? 'Completar cuestionario' : 'Responder')+'</button>'+
            (c.empezado && c.contestadas
              ? '<small class="fv-pend__retomar">Sigues donde lo dejaste · '+c.contestadas+
                (c.contestadas === 1 ? ' respuesta guardada' : ' respuestas guardadas')+'</small>'
              : '')+
          '</div>';
        }).join('')+
      '</div>'+
    '</div>');
}

export default pintarPendientes;
